import { useI18nContext } from '@/i18n/i18n-react';

interface NoDataPlaceholderProps {
  fullHeight?: boolean;
}

export function NoDataPlaceholder({
  fullHeight = false,
}: NoDataPlaceholderProps) {
  const { LL } = useI18nContext();

  return (
    <div
      className={`flex items-center justify-center text-sm text-muted-foreground ${fullHeight ? 'h-full w-full' : 'min-h-10 w-full'}`}
    >
      {LL.metricsPage.warnings.noData()}
    </div>
  );
}
